module.exports = __webpack_public_path__ + "img/tina_s.0be16771.png";